import { ThunkAction } from 'redux-thunk';
import { AnyAction } from 'redux';
import * as stApi from '../api/station-tools-api';
import { RootState } from './reducers';
import { StatisticsFilters } from './statistics.reducer';

export const STATISTICS_GET = 'STATISTICS_GET';
export const STATISTICS_FILTERS_SET = 'STATISTICS_FILTERS_SET';
export const STATISTICS_FILTERS_CLEAR = 'STATISTICS_FILTERS_CLEAR';

export const getStatistics =
  (
    range: { start: string; end: string } | null
  ): ThunkAction<Promise<void>, RootState, unknown, AnyAction> =>
  async dispatch => {
    let events = await stApi.getEvents(range);
    dispatch({ type: STATISTICS_GET, payload: { events } });
  };

export const setStatisticsFilters =
  (
    filters: StatisticsFilters
  ): ThunkAction<void, RootState, unknown, AnyAction> =>
  dispatch => {
    dispatch({ type: STATISTICS_FILTERS_SET, payload: { filters } });
  };

export const clearStatisticsFilters =
  (): ThunkAction<void, RootState, unknown, AnyAction> => dispatch => {
    dispatch({ type: STATISTICS_FILTERS_CLEAR });
  };
